export const UsesoundEnabled = () => useState<boolean>(() => false);
export const UseIsProfessional = () => useState<boolean>(() => false);
export const UserAnimationEnabled = () => useState<boolean>(() => false);
export const UseCursorEnabled = () => useState<boolean>(() => false);
export const UseIsLoading = () => useState<boolean>(() => false);

export const UseIsLoadingTimeout = () =>
  useState<number | undefined>(() => undefined);
